module.exports = __webpack_public_path__ + "img/EgyptTechAxeman3_ua.d5bf0ac4.webp";